import { render, staticRenderFns } from "./ProcessDesign.vue?vue&type=template&id=0472281c&scoped=true"
import script from "./ProcessDesign.vue?vue&type=script&lang=js"
export * from "./ProcessDesign.vue?vue&type=script&lang=js"
import style0 from "./ProcessDesign.vue?vue&type=style&index=0&id=0472281c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0472281c",
  null
  
)

export default component.exports